import { render, staticRenderFns } from "./fdInventory45.vue?vue&type=template&id=452190bf"
import script from "./fdInventory45.vue?vue&type=script&lang=js"
export * from "./fdInventory45.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports